import { appMessages } from '../../../../messages'
import {
  MUSCLE,
  MUSCLE_COMBINATIONS_MESSAGE,
  MUSCLE_MESSAGE
} from '../../constants'
import { getCombinationKeyMuscleUtil } from '../get-combination-key'

export default function getMusclesCombinationMessageWorkoutUtil ({ muscles }) {
  const muscleCombinationKey = getCombinationKeyMuscleUtil({
    muscles,
    shouldNotDefaultToFullBody: true
  })

  if (muscleCombinationKey) {
    return {
      message: MUSCLE_COMBINATIONS_MESSAGE[muscleCombinationKey]
    }
  }

  const muscleMessage = (
    MUSCLE_MESSAGE[muscles[0]] ||
    MUSCLE_MESSAGE[MUSCLE.ABS]
  )

  if (muscles.length > 1) {
    return {
      message: appMessages.valueAndMorePlus,
      params: {
        value: {
          message: muscleMessage
        }
      }
    }
  }

  return {
    message: muscleMessage
  }
}
